import { queryOptions } from "@tanstack/react-query";
import { getProductsFee } from "api-client";

export function productsFeeQueryOptions() {
  return queryOptions({
    queryKey: ["products-fee"],
    queryFn: async () => {
      const response = await getProductsFee();
      return response.data.data;
    },
  });
}
